import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createMemberRoleDefinitionRequest = {};
var _createMemberRoleDefinitionResponse = {};
var _deleteMemberRoleDefinitionRequest = {};
var _deleteMemberRoleDefinitionResponse = {};
var _getMemberRoleDefinitionRequest = {};
var _getMemberRoleDefinitionResponse = {};
var _listMemberRoleDefinitionsRequest = {};
var _listMemberRoleDefinitionsResponse = {};
var _syncMetaSiteRolesRequest = {};
var _syncMetaSiteRolesResponse = {};
var _updateMemberRoleDefinitionRequest = {};
var _updateMemberRoleDefinitionResponse = {};
function resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/members/v1/roles',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'members.wixapps.net': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/roles',
                destPath: '/v1/roles',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function syncMetaSiteRoles(payload) {
    var _a = serializer(_syncMetaSiteRolesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_syncMetaSiteRolesResponse, {}).fromJSON;
    function __syncMetaSiteRoles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_role_definition',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoleDefinitions.SyncMetaSiteRoles',
            url: resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl({
                protoPath: '/v1/roles/sync-metasite-roles',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __syncMetaSiteRoles.fromReq = fromReq;
    __syncMetaSiteRoles.__isAmbassador = true;
    return __syncMetaSiteRoles;
}
export function createMemberRoleDefinition(payload) {
    var _a = serializer(_createMemberRoleDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMemberRoleDefinitionResponse, {}).fromJSON;
    function __createMemberRoleDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_role_definition',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoleDefinitions.CreateMemberRoleDefinition',
            url: resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl({
                protoPath: '/v1/roles/definitions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMemberRoleDefinition.fromReq = fromReq;
    __createMemberRoleDefinition.__isAmbassador = true;
    return __createMemberRoleDefinition;
}
export function listMemberRoleDefinitions(payload) {
    var _a = serializer(_listMemberRoleDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMemberRoleDefinitionsResponse, {}).fromJSON;
    function __listMemberRoleDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_role_definition',
            method: 'GET',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoleDefinitions.ListMemberRoleDefinitions',
            url: resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl({
                protoPath: '/v1/roles/definitions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMemberRoleDefinitions.fromReq = fromReq;
    __listMemberRoleDefinitions.__isAmbassador = true;
    return __listMemberRoleDefinitions;
}
export function getMemberRoleDefinition(payload) {
    var _a = serializer(_getMemberRoleDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberRoleDefinitionResponse, {}).fromJSON;
    function __getMemberRoleDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_role_definition',
            method: 'GET',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoleDefinitions.GetMemberRoleDefinition',
            url: resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl({
                protoPath: '/v1/roles/definitions/{roleKey}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMemberRoleDefinition.fromReq = fromReq;
    __getMemberRoleDefinition.__isAmbassador = true;
    return __getMemberRoleDefinition;
}
export function updateMemberRoleDefinition(payload) {
    var _a = serializer(_updateMemberRoleDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMemberRoleDefinitionResponse, {}).fromJSON;
    function __updateMemberRoleDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_role_definition',
            method: 'PATCH',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoleDefinitions.UpdateMemberRoleDefinition',
            url: resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl({
                protoPath: '/v1/roles/definitions/{key}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMemberRoleDefinition.fromReq = fromReq;
    __updateMemberRoleDefinition.__isAmbassador = true;
    return __updateMemberRoleDefinition;
}
export function deleteMemberRoleDefinition(payload) {
    var _a = serializer(_deleteMemberRoleDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberRoleDefinitionResponse, {}).fromJSON;
    function __deleteMemberRoleDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_role_definition',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.memberroles.MemberRoleDefinitions.DeleteMemberRoleDefinition',
            url: resolveComWixpressMembersMemberrolesMemberRoleDefinitionsUrl({
                protoPath: '/v1/roles/definitions/{roleKey}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberRoleDefinition.fromReq = fromReq;
    __deleteMemberRoleDefinition.__isAmbassador = true;
    return __deleteMemberRoleDefinition;
}
//# sourceMappingURL=http.impl.js.map